var map = {
	"./FenyxRising.jpg": "rmxP",
	"./FenyxRising.mp4": "2SrX",
	"./Honkai.jpg": "gAnD",
	"./Honkai_cn.mp4": "ofm7",
	"./Honkai_en.mp4": "5BiK",
	"./Horizon.jpg": "Pb/b",
	"./Horizon.mp4": "yMQG",
	"./KOF14.jpg": "36gS",
	"./KOF14.mp4": "3QyL",
	"./KOF15.jpg": "kxrU",
	"./KOF15.mp4": "lOx8",
	"./MEIXUAN.mp4": "/4U1",
	"./RhythmPlanet.jpg": "tzkB",
	"./RhythmPlanet.mp4": "YeHB",
	"./SAMURAISHODOWN.jpg": "FSoU",
	"./TowerOfFantacy.jpg": "Yd/v",
	"./TowerOfFantacy.mp4": "77gu",
	"./UD.jpg": "6Kkl",
	"./UD.mp4": "yoKn",
	"./Video01.jpg": "7qW9",
	"./Video01.mp4": "I/I5",
	"./Video02.jpg": "mUbf",
	"./Video02.mp4": "+4wt",
	"./Video03.jpg": "PXwf",
	"./Video03.mp4": "wOeZ",
	"./WRC8.mp4": "MX/x",
	"./wrc8.jpg": "ZuP7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ut+F";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio ^\.\/.*$
// module id = ut+F
// module chunks = 0